import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import { Card } from '../ui';
import { formatUsdSigned } from '../../lib/format';

interface Props {
  pnl: number;
}

/** Trades-tab header: total realised PnL across the active filter. */
export function TotalPnlCard({ pnl }: Props) {
  const { t } = useTranslation();
  return (
    <Card pad="md" className="flex items-baseline justify-between">
      <span className="pb-eyebrow">{t('activity.total_earned')}</span>
      <span
        className={clsx(
          'pb-numeral text-[22px]',
          pnl > 0 && 'text-pb-success',
          pnl < 0 && 'text-pb-danger',
          pnl === 0 && 'text-tg-text',
        )}
      >
        {formatUsdSigned(pnl)}
      </span>
    </Card>
  );
}
